import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetTSPsQuery } from '../services/edgeApi';
import { selectAdvancedPriceComponentFilters } from '../filters/advancedFiltersSelectors';
import { selectTspOptions } from '../map/slice/mapSelectors';
import { MultiSelectButton, MultiSelectSearch } from '../helpers/MultiSelect';
import { advancedFiltersActions } from '../filters/advancedFiltersSlice';
import { BuyOrSell } from '../types/api/PriceComponent';

const priceTypeOptions = [
  { value: BuyOrSell.BUY, label: 'Buy' },
  { value: BuyOrSell.SELL, label: 'Sell' },
  { value: BuyOrSell.BOTH, label: 'Both' },
];

export const PriceComponentFilters = () => {
  useGetTSPsQuery(undefined);
  const dispatch = useDispatch();

  const tspOptions = useSelector(selectTspOptions);
  const priceComponentFilters = useSelector(
    selectAdvancedPriceComponentFilters,
  );

  return (
    <div className="my-2 p-3">
      <div className="row">
        <div className="col">
          <MultiSelectButton
            title="Conditions"
            options={[
              { id: 'hasPoints=true', name: 'Has Points' },
              { id: 'hasPoints=false', name: 'No Points' },
              { id: 'mapped=true', name: 'Mapped' },
              { id: 'mapped=false', name: 'Unmapped' },
            ]}
            markedFirst={false}
            keyExtractor={(option) => option.id}
            isMarked={({ id }) => {
              const [field, value] = id.split('=');
              // @ts-ignore
              return priceComponentFilters[field] === JSON.parse(value);
            }}
            onToggle={(option, isMarked) => {
              const [field, value] = option.id.split('=');
              const filterValue = isMarked ? JSON.parse(value) : null;
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'priceComponents',
                  field,
                  value: filterValue,
                }),
              );
            }}
            optionRenderer={(option) => option.name}
          />
        </div>
        <div className="col">
          <input
            className="form-control"
            placeholder="Search"
            value={priceComponentFilters.textSearch ?? ''}
            onChange={(evt) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'priceComponents',
                  field: 'textSearch',
                  value: evt.target.value,
                }),
              )
            }
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="TSP"
            options={tspOptions}
            value={priceComponentFilters.tsps}
            onChange={(options) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'priceComponents',
                  field: 'tsps',
                  value: options.map((option) => option.value),
                }),
              )
            }
          />
        </div>
        <div className="col">
          <MultiSelectSearch
            placeholder="Price Type"
            options={priceTypeOptions}
            value={priceComponentFilters.priceTypes}
            onChange={(options) =>
              dispatch(
                advancedFiltersActions.setFilterValue({
                  type: 'priceComponents',
                  field: 'priceTypes',
                  value: options.map((option) => option.value),
                }),
              )
            }
          />
        </div>
      </div>
    </div>
  );
};
